import { useQuery } from '@tanstack/react-query';
import { remixApi } from '@tectonic/api-client';
import { queryKeys } from '../../queryKeys';


const useCrossSellProductSearch = (slug?: string) => {
  if (!slug) {
    throw new Error('useCrossSellProductSearch: collection is required');
  }

  const { data: looks, ...others } = useQuery({
    queryKey: queryKeys.productLooks(slug),
    queryFn: async () => remixApi.getProductLooks(slug),
  });

  const look = looks?.hits[0]

  const products = look?.products.map((product) => product.product) ?? [];

  return { data: products, ...others };
};

export { useCrossSellProductSearch };
